import React, { useRef, useState } from "react";
import { Row, Col, Container, Button, Card, Nav, Form } from "react-bootstrap";
import MapPoint from "../assets/images/map-point.svg";
import DealIcon from "../assets/images/deal-icon.svg";
import CalendarIconRed from "../assets/images/calendar-about.svg";
import AvailableIcon from "../assets/images/rent-deal/1.svg";
import ParkingLotIcon from "../assets/images/rent-deal/3.svg";
import DownArrow from "../assets/images/down-arrow.svg";
import CommunityIcon from "../assets/images/community.svg";
import WalkIcon from "../assets/images/man-1.svg";
import BikeIcon from "../assets/images/man-2.svg";
import ArrowRight from "../assets/images/arrow-right.svg";
import { Link } from "react-router-dom";
import PetsIcon from "../assets/images/pet.svg";
import CurrencyIcon from "../assets/images/currency.svg";
import RequestTourModal from './RequestTourModal';
import ConfirmTourModal from './ConfirmTourModal';
import { formatRentalPeriod } from "../utils/formatRentalPeriod";
import TownhomeIcon from '../assets/images/about-home/2.svg'
import YearBuiltIcon from '../assets/images/about-home/3.svg'
import LotSizeIcon from '../assets/images/about-home/4.svg'
import ContactAgentModal from './ContactAgentModal';
import Swal from "sweetalert2";




function ProductCommercialDetails({ property }) {
    const handleShowContactModal = () => setShowContactModal(true);

  const [showContactModal, setShowContactModal] = useState(false);
  const handleCloseContactModal = () => setShowContactModal(false);
  const [message, setMessage] = useState('');
  const [preferred_move_in_date, setPreferredMoveInDate] = useState('');

  const [showFullDescription, setShowFullDescription] = useState(false);
  const [activeTab, setActiveTab] = useState("schools");
  const [activeFloorTab, setActiveFloorTab] = useState("summary");
  const dateInputRef = useRef(null);
  const handleContainerClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };
  const MAX_LENGTH = 320;

  const shortDescription =
    property.description.length > MAX_LENGTH
      ? property.description.slice(0, MAX_LENGTH)
      : property.description;

 
  const commercialUnits = property?.commercial_units || [];

  const unitTypeGroups = commercialUnits.reduce((acc, unit) => {
    acc[unit.unit_type] = acc[unit.unit_type] || [];
    acc[unit.unit_type].push(unit);
    return acc;
  }, {});

  console.log("Unit Type Groups:", unitTypeGroups);

  //send
  const handleSend = () => {
    if (message.trim() === '' || preferred_move_in_date.trim() === '') {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please fill in all fields.',
      });
      return;
    } else {
      setShowContactModal(true);
    }

  };


  const CommercialUnitCard = ({ unit }) => (
    <div className="card-box">
      <h5>
        {unit.unit_name}
      </h5>

      <Card>
        <Row>
          <Col md={8} className="d-flex flex-column justify-content-center">
            <h6>{unit.unit_name}</h6>

            {unit.rent_per_sqft && (
              <h5>
                KES {unit.rent_per_sqft} / Sqft
              </h5>
            )}

            <p>
              {unit.size_sqft} Sqft
              {unit.lease_term_years && (
                <> • {unit.lease_term_years} Year Lease</>
              )}
            </p>

            {unit.fit_out_status && (
              <p className="text-muted">
                Fit-out: {unit.fit_out_status}
              </p>
            )}

            <Button className="custom-bttn style-3">
              {unit.available_units} Unit
              {unit.available_units > 1 ? 's' : ''} available
            </Button>
          </Col>

          <Col md={4}>
            <Card.Img
              src={property?.main_image}
              alt={unit.unit_name}
            />
          </Col>
        </Row>
      </Card>
    </div>
  );

  const [showRequestTourModal, setShowRequestTourModal] = useState(false);
  const [showConfirmTourModal, setShowConfirmTourModal] = useState(false);
  const [tourData, setTourData] = useState(null);
  const handleShowRequestTour = () => setShowRequestTourModal(true);
  const handleCloseRequestTour = () => setShowRequestTourModal(false);
  const handleCloseConfirmTour = () => setShowConfirmTourModal(false);
  const handleNextFromRequestTour = (data) => {
    setTourData(data);
    setShowRequestTourModal(false);
    setShowConfirmTourModal(true);
  };

  return (
    <>
      <div className="product-info-section">
        <Container>
          <Row>
            <Col md={12} lg={8} xl={9}>
              <div className="sale-box">
                <Row className="g-4">
                  <Col md={12} lg={8} xl={9}>
                    {/* Status Badge */}
                    <p className="badge">
                      {property.listing_type === "rent" ? (
                        <>
                          <span className="rent"></span>
                          FOR RENT
                        </>
                      ) : (
                        <>
                          <span className="sale"></span>
                          FOR SALE
                        </>
                      )}
                    </p>

                    {/* Price Section */}
                    <div className="price-section">
                      <h1 className="price-main">KES{property.price}
                        {/*show slash and term for rent only*/}
                        {property.listing_type === "rent" && (
                          <span className="rent"> {formatRentalPeriod(property.rental_term)}</span>
                        )}
                      </h1>
                    </div>

                    {/* Property Details */}
                    <div className="property-details d-flex align-items-center">
                      <span>{property.details.floor_count} fl</span>
                      <span className="dot"></span>
                      <span>{property.details.power_capacity_kva} kVA</span>
                      <span className="dot"></span>
                      <span>{property.size_sqft} sq ft</span>
                    </div>

                    {/* Address */}
                    <div className="address-section">
                      <p>{property.street_address}</p>
                    </div>
                  </Col>

                  {/* Map Column */}
                  <Col md={12} lg={4} xl={3}>
                    <div
                      className="map-container rounded overflow-hidden shadow-sm"
                      style={{ height: "129px" }}
                    >
                      <iframe
                        src={`https://www.google.com/maps?q=${property.latitude},${property.longitude}&z=15&output=embed`}
                        width="100%"
                        height="100%"
                        style={{ border: 0, pointerEvents: 'none' }}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Property Location"
                      />
                      <div className="custom-map-marker">
                        <img src={MapPoint} alt="Map Marker" />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="about-home" id="Highlights">
                <h3>Building highlights</h3>
                {property.deals?.length > 0 &&
                  property.deals.map((item, index) => (
                    <div className="deal-card" key={index}>
                      <div className="deal-icon">
                        <img src={DealIcon} alt="Deal" />
                      </div>
                      <div className="deal-content">
                        <h6>Deal</h6>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))
                }


                {/* Property Info Grid */}
                <Row className="g-3">
                  <Col xs={12} md={4}>
                    <div className="info-card">
                      <div className="info-icon ">
                        <img src={AvailableIcon} alt="Available now" />
                      </div>
                      <div className="info-content">
                        <h6>{property.is_available ? "Available now" : "Not available"}</h6>
                        <p>Availability</p>
                      </div>
                    </div>
                  </Col>

                  <Col xs={12} md={4}>
                    <div className="info-card">
                      <div className="info-icon me-3">
                        <img src={TownhomeIcon} alt="Pets Welcome" />
                      </div>
                      <div className="info-content">
                        <h6 className="mb-0 fw-bold">{property.category?.name}</h6>
                        <p className="mb-0 text-muted small">Property Type</p>
                      </div>
                    </div>
                  </Col>

                  <Col xs={12} md={4}>
                    <div className="info-card">
                      <div className="info-icon me-3">
                        <img src={YearBuiltIcon} alt="Parking Lot" />
                      </div>
                      <div className="info-content">
                        <h6 className="mb-0 fw-bold">{property.year_built}</h6>
                        <p className="mb-0 text-muted small">Year Built</p>
                      </div>
                    </div>
                  </Col>

                  <Col xs={12} md={4}>
                    <div className="info-card">
                      <div className="info-icon me-3">
                        <img src={LotSizeIcon} alt="Car dependent" />
                      </div>
                      <div className="info-content">
                        <h6 className="mb-0 fw-bold">{property.size_sqft} sq ft</h6>
                        <p className="mb-0 text-muted small">Lot Size</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
              {/*only for rent*/}
              {property.listing_type === "rent" && (
                <div className="floor-plans" id="FloorPlan">
                  <h3>Available Units</h3>
                  {/* Tabs Navigation */}
                  <Nav variant="tabs" className="around-tabs">
                    <Nav.Item>
                      <Nav.Link
                        active={activeFloorTab === 'summary'}
                        onClick={() => setActiveFloorTab('summary')}
                      >
                        Summary
                      </Nav.Link>
                    </Nav.Item>

                    {Object.entries(unitTypeGroups).map(([type, units]) => (
                      <Nav.Item key={type}>
                        <Nav.Link
                          active={activeFloorTab === `type-${type}`}
                          onClick={() => setActiveFloorTab(`type-${type}`)}
                        >
                          {type} ({units.length})
                        </Nav.Link>
                      </Nav.Item>
                    ))
                    }
                  </Nav>

                  {activeFloorTab === 'summary' && (
                    <div className="tab-content-wrap">
                      {commercialUnits.map(unit => (
                        <CommercialUnitCard key={unit.id} unit={unit} />
                      ))}
                    </div>
                  )}

                  {Object.entries(unitTypeGroups).map(([type, units]) =>
                    activeFloorTab === `type-${type}` ? (
                      <div className="tab-content-wrap" key={type}>
                        {units.map(unit => (
                          <CommercialUnitCard key={unit.id} unit={unit} />
                        ))}
                      </div>
                    ) : null
                  )}

                </div>
              )}
              <div className="about-home">
                <h3>About this property</h3>

                {/* Description */}
                <div className="about-description">
                  <p>
                    {showFullDescription ? property.description : shortDescription}
                    {!showFullDescription &&
                      property.description.length > MAX_LENGTH &&
                      '...'}
                  </p>

                  {showFullDescription && (
                    <div className="office-hours">
                      <h3>Office Hours</h3>

                      {property.office_hours.map((item) => (
                        <p key={item.day}>
                          {item.day}{' '}
                          {item.isOpen ? (
                            <span className="text-skyblue">
                              {item.opensAt} – {item.closesAt}
                            </span>
                          ) : (
                            <span className="text-red">Closed</span>
                          )}
                        </p>
                      ))}

                      {property.office_hours.some(h => h.appointmentOnly) && (
                        <p className="text-gray">Tours by appointment only</p>
                      )}
                    </div>

                  )}
                  <Button
                    variant="link"
                    className="p-0 text-decoration-none show-more-btn"
                    onClick={() => setShowFullDescription(!showFullDescription)}
                  >
                    {showFullDescription ? 'Show Less' : 'Show More'}
                    <img src={DownArrow} alt="" className={showFullDescription ? 'rotate-180' : ''} />
                  </Button>
                </div>
              </div>

              <div className="fees-policies" id="Amenities">
                <h3>Amenities</h3>
                <div className="policy-section">
                  <div className="policy-header d-flex align-items-center">
                    <img src={ParkingLotIcon} alt="In-unit" />
                    <h4>Parking</h4>
                  </div>
                  <div className="policy-content">
                    <Row>
                      <Col xs={12}>
                        <div className="policy-item">
                           {property.parking_spaces} parking space
                          {property.parking_space > 1 ? "s" : ""} available
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="policy-section">
                  <div className="policy-header d-flex align-items-center">
                    <img src={CommunityIcon} alt="Community" />
                    <h4>Amenities</h4>
                  </div>
                  <div className="policy-content">
                    <Row>
                      <Col xs={12}>
                        <div className="policy-item mb-0">
                         <ul className="list-unstyled">
                            {Object.entries(property.amenities).map(
                              ([category, items]) => (
                                <li key={category} className="mb-4">
                                  <h6 className="mb-2">{category}</h6>{" "}
                                  {/* Category header above */}
                                  {/* Items in 2-column grid */}
                                  <div className="row">
                                    {items.map((p, index) => (
                                      <div key={index} className="col-6 mb-2">
                                        {p.name}
                                      </div>
                                    ))}
                                  </div>
                                </li>
                              ),
                            )}
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

            </Col>
            <Col md={12} lg={4} xl={3}>
            
              <div className="product-sidebar mb-3">

                {property.listing_type==="rent" ? (
                <>
                <h3>{property.name}</h3>
                <Form className="contact-form">
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Write a message <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      name="message"
                      as="textarea"
                      rows={3}
                      placeholder="Write here..."
                      className="form-textarea"
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>
                      Preferred Move In Date <span className="text-danger">*</span>
                    </Form.Label>
                    <div className="date-input-wrapper position-relative" onClick={handleContainerClick}>
                      <Form.Control
                        name="preferred_move_in_date"
                        type="date"
                        placeholder="Select a date"
                        className="form-date-input"
                        ref={dateInputRef}
                        onChange={(e) => setPreferredMoveInDate(e.target.value)}
                      />
                      <img
                        src={CalendarIconRed}
                        alt="Calendar"
                        className="calendar-icon"
                      />
                    </div>
                  </Form.Group>

                  <Button onClick={handleSend} className="custom-bttn w-100 style-3">
                    Send
                  </Button>
                </Form>
                </>
                ): (
                  <>
                 <Button className="custom-bttn w-100 style-3  mb-3" onClick={handleShowContactModal}>
                  Contact an Agent
                </Button>
                <p>Make a winning offer with the help of a local agent.</p>
                </>
                )}
              </div>
              <div className="product-sidebar">
                <h3>Ready to tour?</h3>
                <Button className="custom-bttn w-100 mb-3" onClick={handleShowRequestTour}>
                  Request a Tour
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ContactAgentModal listing_type={property.listing_type} property_id={property.id} show={showContactModal} handleClose={handleCloseContactModal} message={message} preferred_move_in_date={preferred_move_in_date} />
      <RequestTourModal main_image={property.main_image} property_id={property.id} slots={property.slots} street_address={property.street_address}
        beds={property.details.bedrooms} baths={property.details.bathrooms} size={property.size_sqft}
        show={showRequestTourModal}
        handleClose={handleCloseRequestTour}
        onNext={handleNextFromRequestTour}
      />

      <ConfirmTourModal
        show={showConfirmTourModal}
        handleClose={handleCloseConfirmTour}
        tourData={tourData}
      />
    </>
  );
}
export default ProductCommercialDetails;
